import {Button} from "@material-ui/core";
import ClickableDropdown from "../../dropdowns/clickable-dropdown/ClickableDropdown";
import PropTypes from "prop-types";
import {useState} from "react";

const ButtonWithDropDownMenu = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const openDropDownMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return <>
        <Button variant={props.variant}
                color={props.color}
                disabled={props.disabled}
                onClick={openDropDownMenu}>
            {props.text}
        </Button>

        <ClickableDropdown
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            menuItems={props.dropDownMenuItems}
        />
    </>
}

ButtonWithDropDownMenu.propTypes = {
    text: PropTypes.string.isRequired,
    color: PropTypes.string,
    variant: PropTypes.oneOf(["contained", "outlined", "text"]),
    dropDownMenuItems: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            icon: PropTypes.element,
            disabled: PropTypes.bool,
            handleClick: PropTypes.func.isRequired,
            roles: PropTypes.string
        }).isRequired
    ).isRequired,
    disabled: PropTypes.bool.isRequired,
}

ButtonWithDropDownMenu.defaultProps = {
    color: "primary",
    variant: "contained"
}

export default ButtonWithDropDownMenu;
